import React from 'react';
import PageHeading from '../components/PageHeading';
import { Wrapper } from '../css_global/utils.css';
import ContactUsContent from '../../components_common/ContactUs';

const ContactUs = () => (
  <Wrapper>
    <PageHeading text="CONTACT US" />
    <Wrapper>
      <ContactUsContent />
    </Wrapper>
  </Wrapper>
);

export default ContactUs;
